import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BankRecActListItem extends SearchModelBase {
    fDate: string | null = null;
    fromFDate: string | null = null;
    toFDate: string | null = null;
    bankId: number = 0;
    bankName: string = '';
    bookValue: number|null = null;
    fromBookValue: number|null = null;
    toBookValue: number|null = null;
    bankValue: number|null = null;
    fromBankValue: number|null = null;
    toBankValue: number|null = null;
    difference: number|null = null;
    fromDifference: number|null = null;
    toDifference: number|null = null;
    remark: string = '';
    u1ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    id: number = 0;
    inValue: number|null = null;
    fromInValue: number|null = null;
    toInValue: number|null = null;
    outValue: number|null = null;
    fromOutValue: number|null = null;
    toOutValue: number|null = null;
    curBalance: number|null = null;
    fromCurBalance: number|null = null;
    toCurBalance: number|null = null;
    pdCheck: number|null = null;
    fromPDCheck: number|null = null;
    toPDCheck: number|null = null;
    ppCheck: number|null = null;
    fromPPCheck: number|null = null;
    toPPCheck: number|null = null;
    currency: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'fDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Bank', width: 200, dataIndex: 'bankName'}),
        XCol.Create({ col: 3, text: 'CUR', width: 40, dataIndex: 'currency', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'In', width: 100, dataIndex: 'inValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'Out', width: 100, dataIndex: 'outValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Book Value', width: 100, dataIndex: 'bookValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        // XCol.Create({ col: 5, text: 'Processing Deposit', width: 120, dataIndex: 'inValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        // XCol.Create({ col: 6, text: 'Processing Paid', width: 120, dataIndex: 'outValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 7, text: 'Bank Value', width: 100, dataIndex: 'bankValue', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Difference', width: 100, dataIndex: 'difference', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 9, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 11, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: BankRecActListItem.prototype.fDate, orderByAscending: false };

    public static formatData(data: BankRecActListItem[]) {
        return data.map((d: BankRecActListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        fDate: {from: 'fromFDate', to: 'toFDate'},
        bookValue: {from: 'fromBookValue', to: 'toBookValue'},
        bankValue: {from: 'fromBankValue', to: 'toBankValue'},
        difference: {from: 'fromDifference', to: 'toDifference'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        inValue: {from: 'fromInValue', to: 'toInValue'},
        outValue: {from: 'fromOutValue', to: 'toOutValue'},
        curBalance: {from: 'fromCurBalance', to: 'toCurBalance'},
        pdCheck: {from: 'fromPDCheck', to: 'toPDCheck'},
        ppCheck: {from: 'fromPPCheck', to: 'toPPCheck'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }

}
